// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag9P7muVX5U3SPY5izrK{justify-content:flex-start;align-items:center;padding:64px 84px 0;display:flex;overflow-x:hidden;overflow-y:auto}.ae4Ps755tvMKK5taxJ6y{grid-template-rows:max-content max-content 1fr;width:100%;height:100%;display:grid;position:relative;overflow:hidden}.fsnGMPkiKhk_GChAjMXC{grid-template-columns:230px 1fr;display:grid;overflow:hidden}@media (min-width:992px){.fsnGMPkiKhk_GChAjMXC{grid-template-columns:270px 1fr}}@media (min-width:1440px){.fsnGMPkiKhk_GChAjMXC{grid-template-columns:420px 1fr}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `ag9P7muVX5U3SPY5izrK`,
	"content": `ae4Ps755tvMKK5taxJ6y`,
	"savedRepliesContent": `fsnGMPkiKhk_GChAjMXC`
};
export default ___CSS_LOADER_EXPORT___;
